import './../spark-components/bootstrap';
import './shared/icons/icons';
import './bootstrap-vue';
import '../livewire/plugins';
import Loading from 'vue-loading-overlay';
import PortalVue from 'portal-vue';
import SupportRequestModal from './shared/modals/SupportRequestModal';
import AssetCard from './shared/cards/AssetCard';
import DisplayMedia from './shared/creative/DisplayMedia';
import MyTooltip from '@jgile/laravel-vue/resources/js/components/Tooltip';
import RunDates from './shared/RunDates';
import MediaModal from './shared/creative/MediaModal';
import Draggable from 'vuedraggable';
import OrderItemName from './orders/partials/CreativePopper';
import CreativeCarousel from './orders/CreativeCarousel.vue';
import CreativeDisplay from './orders/CreativeDisplay.vue';
import ChangeRequestForm from './orders/modals/ChangeRequestForm.vue';
import DenyCreativeForm from './orders/modals/DenyCreativeForm.vue';
import DenyOrderForm from './orders/modals/DenyOrderForm.vue';
import UpdateCreative from './orders/creative/UpdateCreative.vue';
import ReviewCreativeCarousel from './orders/creative/ReviewCreativeCarousel.vue';
import UpdateCreativeCarousel from './orders/creative/UpdateCreativeCarousel.vue';
import ViewCreativeCarousel from './orders/creative/ViewCreativeCarousel.vue';
import ReviewCreativeModal from './orders/modals/ReviewCreativeModal.vue';
import ViewCreativeModal from './orders/modals/ViewCreativeModal.vue';
import OrdersTable from './orders/table/OrdersTable.vue';
import OrderSearchResults from './orders/table/OrderSearchResults.vue';
import OrderItemsTable from './orders/table/OrderItemsTable.vue';
import ShareOrderItems from '@/orders/partials/ShareOrderItems';
import DownloadOrderItems from '@/orders/partials/DownloadOrderItems';
import OrderStatusKey from '@/orders/OrderStatusKey';
import Messenger from '../../../../packages/jgile/messenger/src/resources/index';
import { JGile } from '../../../../packages/jgile/laravel-vue/resources/js/index';
import Tinker from './tinker/Tinker';
import '../../../../app/Modules/Tasks/resources/js/index';
import VueMarquee from './shared/VueMarquee';
import Multiselect from 'vue-multiselect';
import DisplayCreative from '@/shared/creative/DisplayCreative';
import UpdateTeamSettings from '@/settings/UpdateTeamSettings.vue';
import FavoritesTable from '@/favorites/FavoritesTable.vue';
import FavoriteTeamsTable from '@/favorites/FavoriteTeamsTable.vue';
import Sidebar from '@/navigation/Sidebar.vue';
import RevenueGoals from '@/teams/partials/RevenueGoals.vue';
import BundleCalendarDateModal from '@/assets/BundleCalendarDateModal.vue';
import PromoBundleSuggestedPrice from '@/assets/PromoBundleSuggestedPrice.vue';
import PreviewAndPost from '@/teams/inventory/PreviewAndPost.vue';
import ShareDynamicPricing from '@/teams/inventory/ShareDynamicPricing.vue';
import GlobalMessenger from './shared/GlobalMessenger.vue';

// Components
Vue.component('stripe-embedded-checkout', require('./checkout/StripeEmbeddedCheckout.vue').default);
Vue.component('stripe-checkout', require('./checkout/StripeCheckout.vue').default);
Vue.component('preview-and-post', PreviewAndPost);
Vue.component('share-dynamic-pricing', ShareDynamicPricing);
Vue.component('bundle-calendar-date-modal', BundleCalendarDateModal);
Vue.component('promo-bundle-suggested-price', PromoBundleSuggestedPrice);
Vue.component('revenue-goals', RevenueGoals);
Vue.component('revenue-goals', RevenueGoals);
Vue.component('sidebar', Sidebar);
Vue.component('favorite-teams-table', FavoriteTeamsTable);
Vue.component('favorites-table', FavoritesTable);
Vue.component('update-team-settings', UpdateTeamSettings);
Vue.component('share-order-items', ShareOrderItems);
Vue.component('download-order-items', DownloadOrderItems);
Vue.component('display-creative', DisplayCreative);
Vue.component('multiselect', Multiselect);
Vue.component('vue-marquee', VueMarquee);
Vue.component('multiselect', Multiselect);
Vue.component('tinker', Tinker);
Vue.component('asset-card', AssetCard);
Vue.component('support-request-modal', SupportRequestModal);
Vue.component('run-dates', RunDates);
Vue.component('display-media', DisplayMedia);
Vue.component('tooltip', MyTooltip);
Vue.component('media-modal', MediaModal);
Vue.component('order-item-name', OrderItemName);
Vue.component('order-status-key', OrderStatusKey);
Vue.component('creative-carousel', CreativeCarousel);
Vue.component('creative-display', CreativeDisplay);
Vue.component('change-request-form', ChangeRequestForm);
Vue.component('deny-creative-form', DenyCreativeForm);
Vue.component('deny-order-form', DenyOrderForm);
Vue.component('update-creative', UpdateCreative);
Vue.component('review-creative-carousel', ReviewCreativeCarousel);
Vue.component('update-creative-carousel', UpdateCreativeCarousel);
Vue.component('view-creative-carousel', ViewCreativeCarousel);
Vue.component('review-creative-modal', ReviewCreativeModal);
Vue.component('view-creative-modal', ViewCreativeModal);
Vue.component('orders-table', OrdersTable);
Vue.component('order-search-results', OrderSearchResults);
Vue.component('order-items-table', OrderItemsTable);
Vue.component('global-messenger', GlobalMessenger);

// Plugins
Vue.use(Loading);
Vue.use(JGile);
Vue.use(Draggable);
Vue.use(PortalVue);
Vue.use(Messenger);

/*
|--------------------------------------------------------------------------
| Teams
|--------------------------------------------------------------------------
*/
require('./teams/team-dashboard');
require('./teams/components/asset-preview-actions');
require('./teams/components/asset-actions');
require('./teams/components/asset-favorite');
require('./teams/components/category-menu');
require('./teams/components/category-menu/category-menu-item');
require('./teams/components/category-filter/category-filter');
require('./teams/components/category-filter/category-filter-checkbox');
require('./teams/inventory');
require('./teams/inventory/inventory-manager');
require('./teams/inventory/bundles/update-bundle-details');
require('./teams/inventory/bundles/update-bundle');
require('./teams/inventory/bundles/create-bundle');
require('./teams/inventory/assets/update-asset');
require('./teams/inventory/assets/create-asset');
require('./teams/inventory/inventory-posted');
require('./teams/inventory/inventory-pricing');
require('./teams/calendar/team-calendar');
require('./admin/site-settings/asset-settings');
require('./auth/invitation-registration');

window.loadedMixin = {};
window.addEventListener('livewire:load', function() {
    window.loadedMixin = {
        mounted() {
            console.log('rescan');
            window.Livewire.rescan();
        },
    };
});

function livewireCallback(mod) {
    if (Array.isArray(mod.default.mixins)) {
        mod.default.mixins.push(loadedMixin);
    } else {
        mod.default.mixins = [loadedMixin];
    }

    return mod.default;
}

Vue.component('home-page', () => import('./pages/home').then(mod => livewireCallback(mod)));
Vue.component('advertiser', () => import('./advertisers/advertiser').then(mod => livewireCallback(mod)));
Vue.component('admin-dashboard', () => import('./admin/admin-dashboard').then(mod => livewireCallback(mod)));
Vue.component('team-registration', () => import('./auth/team-registration').then(mod => livewireCallback(mod)));
Vue.component('advertiser-registration', () => import('./auth/advertiser-registration').then(mod => livewireCallback(mod)));
Vue.component('update-team-information', () => import('./settings/update-team-information').then(mod => livewireCallback(mod)));
